<div class="flex flex-col justify-center items-center my-20">
  <div
    class="rounded-full animate-spin border-t-transparent"
    [ngClass]="color"
    [ngStyle]="{
      'width.px': size,
      'height.px': size,
      'border-width.px': borderWidth
    }">
  </div>
  <span *ngIf="text" class="mt-4 text-center text-gray-600">{{ text }}</span>
</div>
